export default __webpack_public_path__ + "static/media/curved-6.71ee1d1c.jpg";